import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DiscountQuotation } from '../models';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class MsQuotationService {

  constructor(private apiService: ApiService) { }

  /**
   * Retorna la diferencia de descuentos y precios de la cotización
   * @param request Objeto de filtros
   */
  reportDiscountQuotation(params: any): Observable<DiscountQuotation[]> {
    return this.apiService
      .get(`${this.apiService.msQuotation}/service/quotation/report-quotation`, params)
      .pipe();
  }
}